export default {
  global: {
    kibana: {
      enabled: false,
    },
  },
  devices: {
    xapInterstitial: true,
    kibana: {
      enabled: true,
    },
    enableGlobalNav: true,
    forceGlobalNav: true,
    cottonFeatureEnabled: true,
    cottonAccountApiEnabled: true,
    cottonDeviceStatusEnabled: true,
    cottonOauthEnabled: true,
    cottonMacaroonEnabled: true,
    cottonSwapsOrdersEnabled: true,
    cottonSwapsOrderEnabled: true,
    cottonSwapsEligibilityEnabled: true,
    cottonHicEnabled: true,
    cottonDsmDevicesEnabled: true,
    cottonDsmReturnsEnabled: true,
    cottonDsmReturnsLabelEnabled: true,
    cottonDsmReturnsNewLabelEnabled: true,
    cottonConsolidatedOutageLob: true,
    cottonItgRecommendationsEnabled: true,
    cottonInternetPlanEnabled: false,
    cottonOutageEnabled: true,
    cottonCmsSupportEnabled: true,
    enableOutageLob: true,
    cottonConsolidatedOutageLobEnabled: true,
    isAptV1Enabled: true,
    cottonInternetUsageEnabled: true,
    disableRubyApis: true,
    useSsmDeviceStatus: true,
    disableNonDigitalReturnsNba: true,
    deviceSwapNba: true,
    enableDevicesHeroHeader: true,
    cottonSikOrderEnabled: true,
    enableElevatedIssueDetection: true,
    enableSmsEnrollOutageNBA: true,
    ubbChargeAmount: true,
    removeCancelTextIE: true,
    enableNED: false,
  },
  'device-returns': {
    disableOrders: false,
    enableXfinityStore: true,
    recommendUps: true,
    upsCallForPickup: true,
    enableHomeDevices: true,
    disableNonDigitalReturns: false,
    xapInterstitial: true,
    kibana: {
      enabled: false,
    },
    returnsDisabled: false,
  },
};
